var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "chat-v" },
    [
      _c(
        "el-drawer",
        {
          attrs: {
            visible: _vm.chatStatus,
            direction: "rtl",
            size: _vm.sreenSmall ? 497 : 1091,
          },
          on: {
            "update:visible": function ($event) {
              _vm.chatStatus = $event
            },
            close: _vm.closeChat,
          },
        },
        [
          _c("div", { staticClass: "drawer-wrap" }, [
            _c(
              "div",
              { staticClass: "chat-title" },
              [
                _c(
                  "el-dropdown",
                  {
                    attrs: {
                      placement: "bottom",
                      trigger: "click",
                      disabled: !_vm.reminderPro,
                    },
                    on: { "visible-change": _vm.changeAIvisible },
                  },
                  [
                    _c(
                      "div",
                      { staticClass: "dropdown-item" },
                      [
                        _c("span", { staticClass: "dropdown-item-text" }, [
                          _vm._v(
                            _vm._s(_vm.aiList[_vm.currentAI].name) +
                              _vm._s(
                                _vm.currentAI == 0
                                  ? ` (${this.useTotal} / ${this.sendTotal}) `
                                  : ""
                              )
                          ),
                        ]),
                        _vm.reminderPro
                          ? _c("svg-icon", {
                              staticClass: "arrow-down",
                              attrs: { name: "position-arrow-down" },
                            })
                          : _vm._e(),
                      ],
                      1
                    ),
                    _c(
                      "el-dropdown-menu",
                      {
                        staticClass: "custom-dropdown",
                        attrs: { slot: "dropdown" },
                        slot: "dropdown",
                      },
                      [
                        _c("el-dropdown-item", [
                          _c(
                            "span",
                            {
                              staticClass: "xiaoyiAI",
                              on: { click: _vm.changeAI },
                            },
                            [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.currentAI == 1
                                      ? _vm.aiList[0].name
                                      : _vm.aiList[1].name
                                  ) +
                                  " "
                              ),
                            ]
                          ),
                        ]),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c("span", { staticClass: "chart-title" }, [
                  _c(
                    "span",
                    { on: { click: _vm.bigChat } },
                    [
                      _vm.sreenSmall
                        ? _c("svg-icon", {
                            staticClass: "newIcon",
                            attrs: { name: "small" },
                          })
                        : _c("svg-icon", {
                            staticClass: "newIcon",
                            attrs: { name: "big" },
                          }),
                    ],
                    1
                  ),
                  _c(
                    "span",
                    { on: { click: _vm.closeChat } },
                    [
                      _c("svg-icon", {
                        staticClass: "newIcon",
                        attrs: { name: "close" },
                      }),
                    ],
                    1
                  ),
                ]),
              ],
              1
            ),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.currentAI == 0,
                    expression: "currentAI == 0",
                  },
                ],
              },
              [
                _c("div", { staticClass: "container" }, [
                  _c(
                    "div",
                    {
                      ref: "list",
                      staticClass: "list-chat",
                      style: { height: _vm.screenHeight },
                      attrs: { id: "list" },
                    },
                    [
                      _c(
                        "ul",
                        [
                          _vm.moreLoadStatus
                            ? _c("div", { staticClass: "loading-m" }, [
                                _c("i", { staticClass: "el-icon-loading" }),
                              ])
                            : _vm._e(),
                          _vm._l(_vm.msglist, function (item, index) {
                            return _c("li", { key: index }, [
                              _c(
                                "div",
                                {
                                  class: [
                                    item.me
                                      ? "containerRight"
                                      : "containerLeft",
                                  ],
                                },
                                [
                                  item.me
                                    ? _c("span", [
                                        _vm.userInfo.email
                                          ? _c(
                                              "span",
                                              { staticClass: "head-user" },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.userInfo.email
                                                      .slice(0, 2)
                                                      .toUpperCase()
                                                  )
                                                ),
                                              ]
                                            )
                                          : _c("img", {
                                              staticClass: "head",
                                              attrs: {
                                                src: require("../../assets/origin.png"),
                                              },
                                            }),
                                      ])
                                    : _c("span", [
                                        _c("img", {
                                          staticClass: "head",
                                          attrs: {
                                            src: require("../../assets/xiaoyi.png"),
                                          },
                                        }),
                                      ]),
                                  _c("div", { staticClass: "content" }, [
                                    item.me
                                      ? _c("div", { staticClass: "text" }, [
                                          _vm._v(
                                            " " + _vm._s(item.content) + " "
                                          ),
                                        ])
                                      : _c(
                                          "div",
                                          { staticClass: "text" },
                                          [
                                            item.history
                                              ? _c("div", [
                                                  _vm._v(_vm._s(item.content)),
                                                ])
                                              : _c(
                                                  "vue-typed-js",
                                                  {
                                                    staticClass:
                                                      "typed-cursor-d",
                                                    attrs: {
                                                      strings: [item.content],
                                                      loop: false,
                                                      startDelay: 300,
                                                      typeSpeed: 100,
                                                      backSpeed: 50,
                                                      contentType: "html",
                                                    },
                                                  },
                                                  [
                                                    _c("span", {
                                                      staticClass: "typing",
                                                      on: {
                                                        click: _vm.openLink,
                                                      },
                                                    }),
                                                  ]
                                                ),
                                            item.content.includes("</a>") &&
                                            _vm.collectStauts
                                              ? _c(
                                                  "div",
                                                  { staticClass: "url-style" },
                                                  [
                                                    _c(
                                                      "span",
                                                      {
                                                        class: [
                                                          _vm.clickIndex ==
                                                          index
                                                            ? "activeSpan"
                                                            : "",
                                                        ],
                                                        on: {
                                                          click: function (
                                                            $event
                                                          ) {
                                                            return _vm.isEffectiveUrl(
                                                              item.content,
                                                              index
                                                            )
                                                          },
                                                        },
                                                      },
                                                      [
                                                        _c("svg-icon", {
                                                          staticClass:
                                                            "icon-url",
                                                          attrs: {
                                                            name: "rightUrl",
                                                          },
                                                        }),
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.$i18.language(
                                                              "网址正确"
                                                            )
                                                          )
                                                        ),
                                                      ],
                                                      1
                                                    ),
                                                    _c(
                                                      "span",
                                                      {
                                                        class: [
                                                          _vm.clickIndexError ==
                                                          index
                                                            ? "activeSpan"
                                                            : "",
                                                        ],
                                                        on: {
                                                          click: function (
                                                            $event
                                                          ) {
                                                            return _vm.errorIndex(
                                                              item.content,
                                                              index
                                                            )
                                                          },
                                                        },
                                                      },
                                                      [
                                                        _c("svg-icon", {
                                                          staticClass:
                                                            "icon-url",
                                                          attrs: {
                                                            name: "errorUrl",
                                                          },
                                                        }),
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.$i18.language(
                                                              "网址错误"
                                                            )
                                                          )
                                                        ),
                                                      ],
                                                      1
                                                    ),
                                                  ]
                                                )
                                              : _vm._e(),
                                          ],
                                          1
                                        ),
                                  ]),
                                ]
                              ),
                            ])
                          }),
                          _vm.loading
                            ? _c("li", [
                                _c(
                                  "div",
                                  { staticClass: "loading-show-style" },
                                  [
                                    _c("img", {
                                      staticClass: "head",
                                      attrs: {
                                        src: require("../../assets/xiaoyi.png"),
                                      },
                                    }),
                                    _c("i", {
                                      staticClass:
                                        "el-icon-loading el-icon-new",
                                    }),
                                  ]
                                ),
                              ])
                            : _vm._e(),
                        ],
                        2
                      ),
                    ]
                  ),
                  _c("div", { staticClass: "bottom" }, [
                    _c(
                      "div",
                      { staticClass: "input-send" },
                      [
                        _c("el-input", {
                          staticClass: "inputTextArea",
                          attrs: {
                            max: "140",
                            maxlength: "140",
                            resize: "none",
                            autosize: { minRows: 1, maxRows: 5 },
                            type: "textarea",
                            readonly: _vm.loading,
                            placeholder: _vm.$i18.language("请输入聊天内容..."),
                          },
                          nativeOn: {
                            keyup: function ($event) {
                              if (
                                !$event.type.indexOf("key") &&
                                _vm._k(
                                  $event.keyCode,
                                  "enter",
                                  13,
                                  $event.key,
                                  "Enter"
                                )
                              )
                                return null
                              return _vm.send.apply(null, arguments)
                            },
                          },
                          model: {
                            value: _vm.sendContent,
                            callback: function ($$v) {
                              _vm.sendContent = $$v
                            },
                            expression: "sendContent",
                          },
                        }),
                        _c(
                          "button",
                          {
                            staticClass: "send",
                            attrs: { disabled: _vm.loading },
                            on: { click: _vm.send },
                          },
                          [_vm._v(_vm._s(_vm.$i18.language("发送")))]
                        ),
                        _c("div", { staticClass: "say" }, [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.$i18.language(
                                  "小易是大语言模型下的人工智能客服，回复内容可能有误，仅供参考。如有任何异议，欢迎请提出"
                                )
                              )
                          ),
                          _c(
                            "span",
                            {
                              staticClass: "feedback",
                              on: { click: _vm.feedback },
                            },
                            [_vm._v(_vm._s(_vm.$i18.language("反馈")))]
                          ),
                          _vm._v(
                            _vm._s(
                              _vm.$i18.language("，我们会尽力核实与优化。")
                            ) + " "
                          ),
                        ]),
                      ],
                      1
                    ),
                  ]),
                ]),
              ]
            ),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.currentAI == 1,
                    expression: "currentAI == 1",
                  },
                ],
                class: ["GPT-box", _vm.sreenSmall ? "" : "index"],
              },
              [
                !_vm.sreenSmall
                  ? _c("history-session", {
                      directives: [
                        {
                          name: "loading",
                          rawName: "v-loading",
                          value: _vm.loading,
                          expression: "loading",
                        },
                      ],
                      ref: "historysession",
                      on: {
                        newDialog: _vm.newDialog,
                        changeActDialog: _vm.changeActDialog,
                      },
                    })
                  : _vm._e(),
                _c("sessionBox", {
                  ref: "sessionBox",
                  attrs: { isRight: _vm.isRight },
                  on: {
                    "update:isRight": function ($event) {
                      _vm.isRight = $event
                    },
                    "update:is-right": function ($event) {
                      _vm.isRight = $event
                    },
                    handleNewSession: _vm.handleNewSession,
                  },
                }),
              ],
              1
            ),
          ]),
        ]
      ),
      _c("datachange-error-dialog", { ref: "datachangeErrorDialog" }),
      _c("chat-table", {
        ref: "chatTable",
        on: { closeF: _vm.closeTable, chatTableF: _vm.chatTableF },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }